import React from "react";
import { AuditLog } from "@common/types/auditLog";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskTitle: React.FC<Props> = ({ log }) => {
    const newTitle =
        (log.diff.find((d) => d.field === "title")?.after?.value as string) ??
        "";

    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the title to&nbsp;<strong>{newTitle}</strong>
            </span>
        </>
    );
};
